import { memo } from 'react'
import {
  Timeline as MuiTimeline,
  TimelineItem as MuiTimelineItem,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineProps,
  TimelineSeparator,
} from '@mui/lab'
import { SxProps } from '@mui/material'
import { timelineStyles as styles } from './Timeline.style'
import { TimelineItemProps } from './Timeline.types'

function Timeline({ sx, ...props }: TimelineProps) {
  return <MuiTimeline sx={[styles.timeLineWrapper, sx] as SxProps} {...props} />
}

export function TimelineItem({
  separatorProps = {},
  dotProps = {},
  connectorProps = {},
  contentProps = {},
  children,
  ...timelineItemProps
}: TimelineItemProps) {
  const { sx: dotSx, ...otherDotProps } = dotProps
  const { sx: connectorSx, ...otherConnectorProps } = connectorProps
  const { sx: contentSx, ...otherContentProps } = contentProps

  return (
    <MuiTimelineItem {...timelineItemProps}>
      <TimelineSeparator {...separatorProps}>
        <TimelineDot sx={[styles.timeLineDot, dotSx] as SxProps} {...otherDotProps} />
        <TimelineConnector
          sx={[styles.timeLineConnector, connectorSx] as SxProps}
          {...otherConnectorProps}
        />
      </TimelineSeparator>
      <TimelineContent sx={[styles.timeLineContent, contentSx] as SxProps} {...otherContentProps}>
        {children}
      </TimelineContent>
    </MuiTimelineItem>
  )
}

export default memo(Timeline)
